<template>
  <div>
    <ModalAlert 
      :id="modalID"
      :variant="'warning'"
      :title="$t('engine.common.dialogAlertLimitSlideSection.lblTitle', languageEngine)"
      :description_="''"
      :confirm="labelConfirm"
      :cancel="$t('engine.common.dialogAlertLimitSlideSection.lblCancel', languageEngine)"
      :confirmVariant="'primary'"
      :showCancel="limit.slideSection < limit.maxSlideSection ? true : false"
      :showClose="false"
      :timer_="10"
      :noCloseOnEsc="true"
      :noCloseOnBackdrop="true"
      @onTimeout_="onConfirm"
      @onConfirm="onConfirm"
      @onCancel="onCancel"
    >
      <template #description v-if="limit.slideSection < limit.maxSlideSection">
        <div class="fs-sa-16">{{ $t('engine.common.dialogAlertLimitSlideSection.lblDescriptionFree1', languageEngine).replace('{NUMBER}', limit.slideSection) }}</div>
      </template>
      <template #description v-else>
        <div class="fs-sa-16">{{ $t('engine.common.dialogAlertLimitSlideSection.lblDescriptionPaid1', languageEngine).replace('{NUMBER}', limit.slideSection) }}</div>
      </template>
    </ModalAlert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  components: {
    ModalAlert,
  },
  data() {
    return {
      modalID: 'modal-alert-limit-slide-section'
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      synceDiff: "design/snapshot/synceDiff",
      modal: "design/modal",
      limit: "design/page/limit"
    }),
    labelConfirm() {
      return this.limit.slideSection < this.limit.maxSlideSection ? this.$t('engine.common.dialogAlertLimitSlideSection.lblUpgradePackage', this.languageEngine) : this.$t('engine.common.dialogAlertLimitSlideSection.lblConfirm', this.languageEngine)
    }
  },
  methods: {
    onConfirm() {
      if(this.limit.slideSection < this.limit.maxSlideSection) { // 6 = Free
        const url = `${process.env.VUE_APP_PUBLIC_URL}/${this.languageEngine}/upgradeplan`;
        window.open(url,'_blank');
      }
      this.$bvModal.hide(this.modalID);
      this.$store.dispatch("design/snapshot/clearDiff");
      this.$store.dispatch("design/setModal", { name: "" });
    },
    onCancel() {
      this.$bvModal.hide(this.modalID);
      this.$store.dispatch("design/snapshot/clearDiff");
      this.$store.dispatch("design/setModal", { name: "" });
    },
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == this.modalID) {
          this.$bvModal.show(this.modalID);
        }
      },
    },
  },
};
</script>